<section class="how-it-works-section">
  <div class="container">
    <div class="row text-center section-header-row">
      <div class="col-12">
        <h2 id="how-it-works-title" class="section-title">From import to go-live</h2>
        <p class="section-subtitle">Bring your member data in, configure your setup, invite members, and launch renewals, events, and payments when your team is ready.</p>
      </div>
    </div>

    <div class="row g-4 justify-content-center">
      <div class="col-sm-6 col-lg-3" *ngFor="let step of migrationSteps; let i = index">
        <div class="migration-step-card h-100">
          <div class="migration-step-number">{{ i + 1 }}</div>
          <h3 class="migration-step-title">{{ step.title }}</h3>
          <p class="migration-step-desc">{{ step.description }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
